import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import { toggleCommentModal } from '../../../../../../slices/modals/reducer';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input } from "reactstrap";
import SimpleBar from "simplebar-react";
import { sendComment } from '../../../../../../slices/campaigns/thunk';
import Comment from './Comment';

function CommentModal() {
  const dispatch = useDispatch();
  // Select Comment State
  const selectCommentState = createSelector((state) => state, (state) => ({
    commentModal: state.Modal.commentModal,
    comments: state.Campaign.comments,
    commentRelationId: state.Campaign.commentRelationId,
    commentType: state.Campaign.commentType,
    user: state.Login.user,
    userList: state.Settings.userList,
  }));
  const {commentModal, commentType, comments, commentRelationId, user, userList} = useSelector(selectCommentState);
  const [commentBox, setCommentBox] = useState("");
  
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(sendComment({ type: commentType, comment: commentBox, relationId: commentRelationId }));
    setCommentBox("");
  }
  return (
    <Modal isOpen={commentModal} toggle={() => dispatch(toggleCommentModal())} centered size="md">
      <ModalHeader className="p-3" toggle={() => dispatch(toggleCommentModal())}>
        <b>Comments</b>
      </ModalHeader>
      <ModalBody className='pt-0 px-0'>
        <SimpleBar style={{ width: "100%", maxHeight: "400px" }} className="w-100 px-3 d-flex px-2">
          <div className='chat-conversation' style={{ height: "auto !important" }} id='chat-conversation'>
            <ul className='list-unstyled chat-conversation-list' id='users-conversation'>
              {(comments || []).map((item, idx) => {
                const foundUser = userList.find(user => user._id === item.userId);
                return (
                  <Comment comment={item.comment} loginId={user.data.userId} userData={foundUser} idx={idx} />
                )
              })}
            </ul>
          </div>
        </SimpleBar>
      </ModalBody>
      <ModalFooter>
        <Form onSubmit={handleSubmit} className='w-100 d-flex flex-nowrap align-items-center gap-2'>
          <Input type='text'
            className='form-control bg-light border-0'
            placeholder='Enter Comment...'
            value={commentBox}
            onChange={(e) => setCommentBox(e.target.value)}
          />
          <button className='btn btn-info' type='submit'> 
            Send
            <i className='ms-2 ri-send-plane-2-fill align-bottom'></i>
          </button>
        </Form>
      </ModalFooter>
    </Modal>
  )
}

export default CommentModal;